import { TFunction } from 'i18next';

import {
  BoardMineralization,
  BoardSoil,
  BoardStatus,
} from 'features/Croptimizer/types';
import { numericValues } from 'utils/helpers';
import { getEfficiencyFormula } from 'features/Croptimizer/utils/calcHelperBoard';

interface Props {
  getY2CurrentProfit?: string | number;
  mineralizationValues: BoardMineralization | null;
  boardStatusValues: BoardStatus | null;
  boardSoilValues: BoardSoil | null;
  optimumValue: number;
  t: TFunction;
}

export const Y3CurrentProfitSecond = ({
  getY2CurrentProfit,
  boardStatusValues,
  mineralizationValues,
  boardSoilValues,
  optimumValue,
  t,
}: Props) => {
  const getSec = (
    ((Math.tan((Number(getY2CurrentProfit) - 5.8) / 1.45) * 54 + 70) /
      100 /
      0.05) *
    5
  ).toFixed(2);

  const ag38 = getEfficiencyFormula(
    Number(mineralizationValues?.month),
    Number(boardStatusValues?.currentPh),
    Number(numericValues(boardStatusValues?.currentSec ?? '')),
    // Number(boardSoilValues?.selected),
    optimumValue,
    Number(numericValues(mineralizationValues?.soilTillage ?? '')),
  );
  const ah38 = getEfficiencyFormula(
    24,
    Number(getY2CurrentProfit),
    Number(getSec),
    // Number(boardSoilValues?.selected),
    optimumValue,
    Number(numericValues(mineralizationValues?.soilTillage ?? '')),
  );
  const ai38 = getEfficiencyFormula(
    36,
    Number(getY2CurrentProfit),
    Number(getSec),
    // Number(boardSoilValues?.selected),
    optimumValue,
    Number(numericValues(mineralizationValues?.soilTillage ?? '')),
  );

  const ag31 = ag38;
  const ah31 = ah38 < ag31 ? ag31 : ah38;
  const ai78 = ah31 / 100;
  const ah78 = ag31 / 100;
  const ah79 = ag31 / 100;
  const ai71 = ai78 - ah78;
  const ah71 = ah78;
  const dose = Number(numericValues(boardSoilValues?.dose ?? '')) / 100;
  const ai79 = ah31 / 100;
  const ai31 = ai38 < ah31 ? ah31 : ai38;
  const aj78 = ai31 / 100;
  const aj71 = aj78 - ai78;
  const aj79 = ai31 / 100;
  const aj72 = aj79 - ai79;
  const ah72 = ah79;
  const aj80 = ai31 / 100;
  const ai80 = ah31 / 100;
  const aj73 = aj80 - ai80;
  const aj81 = ai31 / 100;
  const ai81 = ah31 / 100;
  const aj74 = aj81 - ai81;
  const aj82 = ai31 / 100;
  const ai82 = ah31 / 100;
  const aj75 = aj82 - ai82;

  const annualDecrease = Number(mineralizationValues?.annualDecrease);
  const frequency = Number(boardSoilValues?.split);

  if (mineralizationValues?.cap !== t('no')) {
    if (boardSoilValues?.split === '1') {
      const aj87 = ah71 + ai71 + aj71;
      const calculatedq64 = (annualDecrease * dose * frequency * aj87).toFixed(
        2,
      );
      const p64MinusAnnual = Number(getY2CurrentProfit) - annualDecrease;

      return (p64MinusAnnual + Number(calculatedq64)).toFixed(2);
    }

    if (boardSoilValues?.split === '2') {
      const aj88 = aj72 + ah72;
      const calculatedq65 = (annualDecrease * dose * frequency * aj88).toFixed(
        2,
      );
      const p64MinusAnnual = Number(getY2CurrentProfit) - annualDecrease;

      return (p64MinusAnnual + Number(calculatedq65)).toFixed(2);
    }

    if (boardSoilValues?.split === '3') {
      const aj89 = aj73;
      const calculatedq65 = (annualDecrease * dose * frequency * aj89).toFixed(
        2,
      );
      const p64MinusAnnual =
        Number(getY2CurrentProfit) - annualDecrease * (1 + 1 * 0.3);

      return (p64MinusAnnual + Number(calculatedq65)).toFixed(2);
    }

    if (boardSoilValues?.split === '4') {
      const aj90 = aj74;
      const calculatedq65 = (annualDecrease * dose * frequency * aj90).toFixed(
        2,
      );
      const p64MinusAnnual =
        Number(getY2CurrentProfit) - annualDecrease * (1 + 1 * 0.4);

      return (p64MinusAnnual + Number(calculatedq65)).toFixed(2);
    }

    if (boardSoilValues?.split === '5') {
      const aj91 = aj75;
      const calculatedq65 = (annualDecrease * dose * frequency * aj91).toFixed(
        2,
      );
      const p64MinusAnnual =
        Number(getY2CurrentProfit) - annualDecrease * (1 + 1 * 0.5);

      return (p64MinusAnnual + Number(calculatedq65)).toFixed(2);
    }
  } else {
    if (boardSoilValues?.split === '1') {
      const calculatedq64 = (annualDecrease * dose * frequency).toFixed(2);
      const p64MinusAnnual = Number(getY2CurrentProfit) - annualDecrease;

      return (p64MinusAnnual + Number(calculatedq64)).toFixed(2);
    }

    if (boardSoilValues?.split === '2') {
      const calculatedq64 = (annualDecrease * dose * frequency).toFixed(2);
      const p64MinusAnnual = Number(getY2CurrentProfit) - annualDecrease;

      return (p64MinusAnnual + Number(calculatedq64)).toFixed(2);
    }

    if (boardSoilValues?.split === '3') {
      const p64MinusAnnual =
        Number(getY2CurrentProfit) - annualDecrease * (1 + 1 * 0.3);

      return (p64MinusAnnual + 0).toFixed(2);
    }

    if (boardSoilValues?.split === '4') {
      const p64MinusAnnual =
        Number(getY2CurrentProfit) - annualDecrease * (1 + 1 * 0.4);

      return (p64MinusAnnual + 0).toFixed(2);
    }

    if (boardSoilValues?.split === '5') {
      const p64MinusAnnual =
        Number(getY2CurrentProfit) - annualDecrease * (1 + 1 * 0.5);

      return (p64MinusAnnual + 0).toFixed(2);
    }
  }
};
